module.exports = __webpack_public_path__ + "media/2x/users-by-device-mobile@2x-1c920dd7.png";